module.exports = __webpack_public_path__ + "img/alex_myprofile.8cbc5d60.svg";